module.exports = __webpack_public_path__ + "media/assets/icons/nav_ranking-b3f20dce328817dd7397c12ab088398e.svg";